module.exports = __webpack_public_path__ + "img/dsci0046.9ee34325.jpg";